(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDetailController', OwnProfileDetailController);

    OwnProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OwnProfile'];

    function OwnProfileDetailController($scope, $rootScope, $stateParams, previousState, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('publicGatewayApp:ownProfileUpdate', function(event, result) {
            vm.ownProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
